
import { ConfigurationActions, ConfigurationActionTypes } from '@appStore/configuration/actions';
import { ApplicationConfiguration, Permission, MenuItem, SystemContent } from '@model';

export interface State {
  apiConfigurationLoaded: boolean;
  apiConfiguration: ApplicationConfiguration;
  isAuthSetup: boolean;
  activeClientId: string;
  permissions: Permission[];
  permissionsLoaded: boolean;
  permissionsLoading: boolean;
  menuItems: MenuItem[];
  menuItemsLoaded: boolean;
  errorRefreshPerformed:number;
  systemContentLoaded: boolean;
  systemContent: SystemContent;
}

export const initialState: State = {
  apiConfigurationLoaded: null,
  apiConfiguration: null,
  isAuthSetup: false,
  activeClientId: "",
  permissions: [],
  permissionsLoaded: false,
  permissionsLoading: false,
  menuItems: [],
  menuItemsLoaded: false,
  errorRefreshPerformed:0,
  systemContentLoaded: false,
  systemContent: null
};

export function reducer(state = initialState, action: ConfigurationActions): State {
  switch (action.type) {
    case ConfigurationActionTypes.LoadApiConfiguration:
      return { ...state };
    case ConfigurationActionTypes.LoadApiConfigurationSuccess:
      let apiConfig = { ...action.payload, baseClientId: action.payload.client_id, baseScope: action.payload.scope };
      return { ...state, apiConfiguration: apiConfig, apiConfigurationLoaded: true };
    case ConfigurationActionTypes.LoadApiConfigurationFail:
      return { ...state, apiConfiguration: null, apiConfigurationLoaded: false };

    case ConfigurationActionTypes.SetActiveClient:
      if (!action.payload) {
        return state;
      }
      return { ...state, activeClientId: action.payload };
    case ConfigurationActionTypes.AuthSetupComplete:
      return { ...state, isAuthSetup: true };

    case ConfigurationActionTypes.LoadPermission:
      return { ...state, permissionsLoading: true, permissionsLoaded: false };
    case ConfigurationActionTypes.LoadPermissionSuccess:
      return { ...state, permissions: action.payload, permissionsLoading: false, permissionsLoaded: true };
    case ConfigurationActionTypes.ClearPermission:
      return { ...state, permissionsLoading: false, permissionsLoaded: false };

    case ConfigurationActionTypes.LoadMenuConfiguration:
      return { ...state };
    case ConfigurationActionTypes.LoadMenuConfigurationSuccess:
      return { ...state, menuItems: action.payload, menuItemsLoaded: true };
    case ConfigurationActionTypes.LoadApiConfigurationFail:
      return { ...state, menuItems: null, menuItemsLoaded: false };
    case ConfigurationActionTypes.SetErrorRefreshPerformed:
      return { ...state, errorRefreshPerformed:state.errorRefreshPerformed + 1 };
    case ConfigurationActionTypes.LoadSystemContent:
      return { ...state };
    case ConfigurationActionTypes.LoadSystemContentSuccess:
      return { ...state, systemContent: action.payload, systemContentLoaded: true };
    case ConfigurationActionTypes.LoadSystemContentFail:
      return { ...state, systemContent: null, systemContentLoaded: false }
  }
  return state;
}

export const getApiConfigurationState = (state: State) => state.apiConfiguration;
export const getApiConfigurationLoaded = (state: State) => state.apiConfigurationLoaded;
export const getIsAuthSetup = (state: State) => state.isAuthSetup;
export const getActiveClientId = (state: State) => state.activeClientId;
export const getPermissions = (state: State) => state.permissions;
export const getPermissionsLoaded = (state: State) => state.permissionsLoaded;
export const getPermissionsLoading = (state: State) => state.permissionsLoading;
export const getMenuConfigurationState = (state: State) => state.menuItems;
export const getMenuConfigurationLoaded = (state: State) => state.menuItemsLoaded;
export const getErrorRefreshPerformed = (state: State) => state.errorRefreshPerformed;
export const getSystemContentLoaded = (state: State) => state.systemContentLoaded;
export const getSystemContent = (state: State) => state.systemContent;
